// extracted by mini-css-extract-plugin
export default {"documents":"Documents_documents__kcmI7","header":"Documents_header__Nk799","link":"Documents_link__Ff42g"};